/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copiar'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nombre',
    PROFIT_MARGIN: 'Porcentaje de comisión'
  },
  LABEL: {
    GENERATE_LINK: 'Generar enlace',
    GENERATED_LINK: 'Enlace generado',
    NAME: 'Nombre',
    PROFIT_MARGIN: 'Porcentaje de comisión'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Enlace copiado'
  },
  TOOLTIP: {
    NAME: 'Nombre',
    PROFIT_MARGIN: 'Porcentaje de comisión'
  }
};
